import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { query } from '@angular/animations';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-report',
  templateUrl: './report.component.html',
  styleUrls: ['./report.component.css']
})
export class ReportComponent implements OnInit {

  public menu_item_id = '15';

  typeList = [{ 'type_id': 'customer', 'type_name': 'تقرير أعمار ديون العملاء', 
    'type_name_en': 'Customer Receivable Aging Report' }, 
    { 'type_id': 'supplier', 'type_name': 'تقرير أعمار ديون الموردين', 
    'type_name_en': 'Supplier Receivable Aging Report' }];
  
  model = { 'type_id': 'customer', 'city_id': '0', 'title': 'تقرير أعمار الديون' };
  city_list = [];
  private dp = [];
  displayedColumns = ['acct_number', 'name', 'to_30', 'to_60', 'to_90', 'to_120', 'more_120', 'total'];
  // displayedColumns2 = ['acct_number', 'name', 'to_30', 'to_60', 'to_90', 'to_120', 'more_120', 'total'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  Receivable_Aging_Rep; Rep_Type_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Receivable_Aging_Rep').subscribe((res: string) => {
      this.Receivable_Aging_Rep = res;
    });
    this.model['title'] = this.Receivable_Aging_Rep;

    translate.get('Rep_Type_Msg').subscribe((res: string) => {
      this.Rep_Type_Msg = res;
    });

  }

  ngOnInit() {
    let query = this.queryList.all_city;
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.city_list = data.data['list'];
        this.city_list.unshift({ 'city_id': '0', 'city_name':'الكل', 'city_name_en': 'All' })
      });

    // fix invoice status
    // let obj1 = {cmd: 'fix_inv_status'};
    // this.utils.invokeHttp(this.applicationConstants.acctFile, obj1)
    //   .subscribe(data => {
    //     this.applicationConstants.appComp.hideBusyCursor();
    //     console.log(data);
    //   });
  }

  viewRep() {
    let obj;
    if (this.model['type_id'] == '0') {
      alert(this.Rep_Type_Msg);
      (document.getElementById('type_id') as HTMLInputElement).focus();
      return false;
    }

    //CUSTOMER
    if (this.model['type_id'] == 'customer') 
      obj = { cmd: 'getCustDebt' };

    //SUPPLIER
    else if (this.model['type_id'] == 'supplier')
      obj = { cmd: 'getSuppDebt' };

    if (this.model['city_id'] != '' && this.model['city_id'] != '0')
      obj['city_id'] = this.model['city_id'];

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();
        
        // console.log(data);
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0">';
    html_data += '<tr><td width="100%">';
    if (this.model['type_id'] != '0') {
      this.typeList.forEach(element => {
        if (element.type_id == this.model['type_id']) {
          html_data += element.type_name;
          return;
        }
      });
    }
    html_data += '</td></tr>';
    html_data += '</table>';

    let form = (document.getElementById('form1') as HTMLFormElement);
    let table = (document.getElementById('rep_table2') as HTMLTableElement);
    this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }


}
